import Card from './Card';
import Icon from './Icon';
import styles from './StatCard.module.css';

export type StatCardProps = {
  rotulo: string;
  valor: string;
  icone?: string;
  tom?: 'neutro' | 'positivo' | 'negativo' | 'primario';
  delta?: string;
  deltaTom?: 'bom' | 'ruim' | 'neutro';
  dica?: string;
};

const classesTom = {
  neutro: styles.tomNeutro,
  positivo: styles.tomPositivo,
  negativo: styles.tomNegativo,
  primario: styles.tomPrimario
};

const classesDeltaTom = {
  bom: styles.deltaBom,
  ruim: styles.deltaRuim,
  neutro: styles.deltaNeutro
};

export default function StatCard({
  rotulo,
  valor,
  icone,
  tom = 'neutro',
  delta,
  deltaTom = 'neutro',
  dica
}: StatCardProps) {
  return (
    <Card className={styles.statCard}>
      <div className={styles.topo}>
        <div className={styles.info}>
          <div className={styles.rotulo}>{rotulo}</div>
          <div className={`${styles.valor} ${classesTom[tom]}`}>{valor}</div>
        </div>
        {icone && (
          <div className={styles.icone}>
            <Icon nome={icone} tamanho={20} />
          </div>
        )}
      </div>
      {(delta || dica) && (
        <div className={styles.rodape}>
          {delta && <span className={`${styles.delta} ${classesDeltaTom[deltaTom]}`}>{delta}</span>}
          {dica && <span className={styles.dica}>{dica}</span>}
        </div>
      )}
    </Card>
  );
}
